<template>
    <div>
        <div class="content-header">
            <ol class="breadcrumb">
                <li class="active">银行卡</li>
            </ol>
        </div>
        <div class="title">
            <span>银行卡列表</span>
        </div>

        <div class="content-data" v-if="bankList && 0 < bankList.length">
            <el-table :data="bankList" highlight-current-row border>
                <el-table-column label="序号" type="index"/>
                <el-table-column label="卡号" prop="code"/>
                <el-table-column label="开户银行" prop="bankName"/>
                <el-table-column label="持有人" prop="name"/>
            </el-table>
        </div>
        <div class="content-data" v-else>
            没有查询到数据
        </div>
        <vue-pager v-bind:datafile="fillData" url="bankCard/pageBankCard" v-bind:query="query" v-bind:contentType="contentType" ref="pager" v-bind:init="true"></vue-pager>
    </div>
</template>
<script>
export default {
    data() {
        return {
            query: {},
            bankList:[],
        }
    },
    created() {
        var _this = this;
        _this.query.userId = _this.$route.query.userId;
        console.log(_this.query.userId);
    },
    methods: {
        fillData(_response) {
            var _this = this;
            _this.bankList = _response.items;
        },
        submitQuery(_num) {
            var _this = this;
            if(0==this.query.type){
                delete this.query.type
            }
             _this.bankList = [];
            _this.$refs.pager.gotoPage(_num);
        }
    }
}
</script>
<style scoped>
.table td{
    text-align: center;
}
</style>
